import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faStar,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";

import "./Vission_Mission.css";

const MissionVisionValues = () => {
  const cards = [
    {
      icon: faUsers,
      title: "Our Mission",
      subtitle: "Seamless & legal recruitment!",
      text:
        "To facilitate seamless, legal, and transparent overseas recruitment while ensuring the highest standards of ethical conduct and compliance.",
    },
    {
      icon: faStar,
      title: "Our Vision",
      subtitle: "Connecting global talent!",
      text:
        "To become the most trusted overseas recruitment partner connecting talented professionals with global opportunities.",
    },
    {
      icon: faShieldHalved,
      title: "Our Values",
      subtitle: "Integrity & excellence first!",
      text:
        "Integrity, transparency, excellence, and client satisfaction guide every decision and action we take.",
    },
  ];

  return (
    <section className="mission_section">
      <Container>
        <Row className="g-4">
          {cards.map((card, index) => (
            <Col lg={4} md={6} sm={6} key={index}>
              <div className="mvv_card">
                <div className="mvv_icon_badge">
                  <FontAwesomeIcon icon={card.icon} />
                </div>

                <div className="mvv_content">
                  <h3 className="mvv_title">{card.title}</h3>

                  {card.subtitle && (
                    <div className="mvv_subtitle_wrapper">
                      <p className="mvv_subtitle">{card.subtitle}</p>
                      <span className="mvv_divider"></span>
                    </div>
                  )}

                  <p className="mvv_text">{card.text}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MissionVisionValues;
